// extracted by mini-css-extract-plugin
export default {"brandPromo":"sG-z","carousel":"tG-z"};